/* jshint esversion: 6 */
import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'app/components/common/Modal.jsx';

class StarterLimitModal extends React.Component {
    constructor(props) {
        super(props);

        this.dismissModal = this.dismissModal.bind(this);
        this.onKeyUp = this.onKeyUp.bind(this);

    }

    componentDidMount() {
        document.addEventListener('keyup', this.onKeyUp);
    }

    componentWillUnmount() {
        document.removeEventListener('keyup', this.onKeyUp);
    }

    onKeyUp(e) {

        if (e.key === "Escape") {
            this.dismissModal();
        }

    }

    dismissModal(e) {
       
        this.props.dismissModal();

    }

    render() {
        let modalContent = null;

        modalContent = (
            <div className="trial-end-warning">
                <div className="close-warning" onClick={this.dismissModal} aria-label='close' role="button">
                    <i className="fa fa-times"></i>
                </div>
                <div className="warning-content">
                    <h3 style={{"fontWeight": 500}}>Looks like you need a bigger plan.</h3>
                    <p>The Starter plan only includes 2 socials. You'll need the Basic plan to keep all your current socials connected.</p>
                </div>
                <div className="buttons">
                    <div className="choose-starter" onClick={this.props.confirmStarter} role="button" aria-label="subscribe to starter">
                        Downgrade to Starter Plan
                    </div>
                    <div className="choose-basic" onClick={this.props.confirmBasic} role="button" aria-label="subscribe to basic">
                        Get the Basic Plan
                    </div>
                </div>
                
            </div>
        )

        return (
            <Modal
                content={modalContent}
                boxClass={"trial-end-box"}
                mainClass={"trial-end-content"} />
        );
    }
}

StarterLimitModal.displayName = "StarterLimitModal";

export default StarterLimitModal;
